
const urlBack = 'https://playandlearn.ovh/RequestV2.php'


const  BackendAPI = {
    login: async(dataConnexion)=>{
        // console.log(dataConnexion) 
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type: "loginAdmin",
                data:  dataConnexion
            }),
            isConnected:false
        };
   
        try {
            const response = await fetch(urlBack, requestOptions);
            console.log(response)
            // Vérifiez si la réponse est OK avant d'essayer de lire le JSON
            if (!response.ok) {
                throw new Error(`Erreur HTTP : ${response.status}`);
            }
            // Analyser la réponse en JSON
            const data = await response.json();
            return data;
        } catch (error) {
            console.error("Erreur lors de la connexion :", error);
            return null;
        }
    },
    getGroupes:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getGroupesV2",
                data:{}
            }),
            /* mode:"no-cors", */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        
        const data = await response.json()
        return  data
    },
    getEtudiants:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getEtudiantsV2",
                data:{}
            }),
            /* mode:"no-cors", */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        
        const data = await response.json()
        return  data
    },
    updateEtudiant:async(value,field,id)=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"updateEtudiantV2",
                data:{
                    value:value,
                    field:field,
                    id:id
                }
            }),
            /* mode:'no-cors', */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        
        return response
    },
    createUser:async(user)=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"createEtudiantV2",
                data:{user:user}
            }),
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)
        return response
    },

    getQuestions:async(numJeu)=>{
        console.log(numJeu)
        /* const formattedNumber = (numJeu.replace("Compta ","1").replace("SI ","2")).split("  - ")[0] */
        const formattedNumber = numJeu
            .replace("Compta ", "1")  // remplace "Compta " par "1"
            .replace("SI ", "2")
            .split(" - ")[0]          // coupe avant " - ", ici "1 1"
            .replace(/\s/g, ""); 
        /* console.log(numJeu)
        const formattedNumber = (parseInt(numJeu.split(" - ")[0], 10) + 10).toString().padStart(2, '0') */
        console.log(formattedNumber)
        const nomJeu = `questionsjeu${formattedNumber}`;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            /* mode:"no-cors", */
            body: JSON.stringify({
                type:"getQuestions",
                data:{
                    nomJeu:nomJeu
                }
                
            }),
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        
        const data = await response.json()
        console.log(data)
        return  data

    },
    updateQuestion:async(value,field,id,numJeu)=>{

        const formattedNumber = numJeu
            .replace("Compta ", "1")  // remplace "Compta " par "1"
            .replace("SI ", "2")
            .split(" - ")[0]          // coupe avant " - ", ici "1 1"
            .replace(/\s/g, ""); 
        const nomJeu = `questionsjeu${formattedNumber}`;

        // console.log(nomJeu+" "+field+" "+value+" "+id)

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"updateQuestion",
                data:{
                    value:value,
                    field:field,
                    id:id,
                    nomJeu:nomJeu
                }
                
            }),
           /*  mode:'no-cors', */
            isConnected:false
        };
        const response = await  fetch(urlBack, requestOptions)
        const data = await response.json()
        return data
    },
    createQuestion:async(question,numJeu)=>{
        console.log(question)
        const formattedNumber = numJeu
            .replace("Compta ", "1")  // remplace "Compta " par "1"
            .replace("SI ", "2")
            .split(" - ")[0]          // coupe avant " - ", ici "1 1"
            .replace(/\s/g, ""); 
        const nomJeu = `questionsjeu${formattedNumber}`;


        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"createQuestionV2",
                data:{
                    question:question,
                    nomJeu:nomJeu
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        return  await response.json()
    },

    getClassements:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getClassementV2",
                data:{
                    idUser:-1
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        return  await response.json()
    },

    getStatistiquesApp:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getStatistiquesAppV2",
                data:{
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)

        return  await response.json()
    },
    getStatistiqueJeux:async()=>{
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                type:"getStatistiquesJeuxV2",
                data:{
                }
                
            }),
            /* mode:'no-cors', */
            isConnected:false
        };

        const response = await  fetch(urlBack, requestOptions)
        
        return  await response.json()
    },
};
export default BackendAPI


